module.exports = __webpack_public_path__ + "e6e1255501c44847dd2f49884a172d82-811-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/assets/811-logo.png
// module id = 577
// module chunks = 0